//store/modules/treasurers.js

import axios from './axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
const state = {}
const getters = {}
const actions = {
  async addImage({ commit }, image) {
    let response = await axios.post('/service/fundraiser/addImage', {
      campaign_id: image.campaign_id,
      data: image,
      tableName: 'fundraiser_images',
    })
    await commit('setResponse', response.data)
    return response.data
  },
  async deleteImage({ commit }, image) {
    let response = await axios.post(
      '/service/fundraiser/retire_detailsP',
      image,
    )
    await commit('setResponse', response.data)
    return response.data
  },
}
const mutations = {
  setResponse(state, response) {
    state.resp = response
  },
}
export default {
  state,
  getters,
  actions,
  mutations,
}
